import { render } from "./WikiParts.vue?vue&type=template&id=3ee1970e"
import script from "./WikiParts.vue?vue&type=script&lang=js"
export * from "./WikiParts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__